import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { MapPin, Phone, Facebook, Clock, Info } from 'lucide-react';
import { PHONE, PHONE_TEL, GOOGLE_MAPS_URL, ADDRESS_LINE_1, ADDRESS_LINE_2, FACEBOOK_URL } from '../constants/business';
export function Contact() {
  useDocumentMeta('Contact Kjergaard Sports | Lake Benton, Minnesota', 'Contact Kjergaard Sports in Lake Benton, Minnesota. Get directions, call the store, or check our Facebook page for hours and updates.');
  return <div data-id="element-212">
      <PageHero title="Contact Kjergaard Sports" image="https://cdn.magicpatterns.com/uploads/f5Jp1yjaV9t3nwDxVsC5wU/exterior-front-building.jpg" alt="Kjergaard Sports storefront in Lake Benton, Minnesota" data-id="element-213" />

      <section className="py-20 bg-brand-offwhite" data-id="element-214">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
          <div className="bg-brand-bone rounded-sm overflow-hidden shadow-sm border border-brand-cream" data-id="element-216">
            <div className="grid lg:grid-cols-2" data-id="element-217">
              {/* Contact Info */}
              <div className="p-10 lg:p-16" data-id="element-218">
                <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-8" data-id="element-219">
                  Visit Us in Lake Benton
                </h2>

                <div className="space-y-8 mb-10" data-id="element-220">
                  <div className="flex items-start" data-id="element-221">
                    <MapPin className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-222" />
                    <div data-id="element-223">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-224">
                        Address
                      </h3>
                      <p className="text-brand-charcoal/80" data-id="element-225">
                        Kjergaard Sports
                        <br data-id="element-226" />
                        {ADDRESS_LINE_1}
                        <br data-id="element-227" />
                        {ADDRESS_LINE_2}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-228">
                    <Phone className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-229" />
                    <div data-id="element-230">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-231">
                        Phone
                      </h3>
                      <a href={PHONE_TEL} className="text-brand-hunter hover:text-brand-wood font-medium text-lg transition-colors" data-id="element-232">
                        {PHONE}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-233">
                    <Clock className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-234" />
                    <div data-id="element-235">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-236">
                        Hours & Updates
                      </h3>
                      <p className="text-brand-charcoal/80" data-id="element-237">
                        Please call or check Facebook for current hours, class
                        dates, and store updates.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-4 mb-12" data-id="element-238">
                  <a href={PHONE_TEL} className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-239">
                    <Phone className="w-4 h-4 mr-2" data-id="element-240" />
                    Call the Store
                  </a>
                  <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="border border-brand-hunter text-brand-hunter hover:bg-brand-hunter hover:text-brand-offwhite px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-241">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-242" />
                    Get Directions
                  </a>
                  <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="bg-[#1877F2] hover:bg-[#0c5dc7] text-white px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-243">
                    <Facebook className="w-4 h-4 mr-2" data-id="element-244" />
                    Follow on Facebook
                  </a>
                </div>

                {/* Contact Form Placeholder */}
                <div className="pt-8 border-t border-brand-cream" data-id="element-245">
                  <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-246">
                    Send a Message
                  </h3>
                  <div className="bg-brand-offwhite border border-brand-cream p-6 rounded-sm flex items-start" data-id="element-247">
                    <Info className="w-5 h-5 text-brand-leather mr-3 flex-shrink-0 mt-0.5" data-id="element-248" />
                    <p className="text-brand-charcoal/80 text-sm leading-relaxed" data-id="element-249">
                      Form will be connected in WebsiteForge during final site
                      setup. For immediate assistance, please call the store at{' '}
                      {PHONE}.
                    </p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-brand-cream relative min-h-[400px] flex items-center justify-center p-8 border-l border-brand-cream overflow-hidden" data-id="element-250">
                <img src="https://cdn.magicpatterns.com/uploads/f5Jp1yjaV9t3nwDxVsC5wU/exterior-front-building.jpg" alt="Kjergaard Sports exterior" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-251" />
                <div className="relative z-10 text-center bg-brand-offwhite/95 backdrop-blur-sm p-10 rounded-sm shadow-md border border-brand-bone max-w-sm w-full" data-id="element-252">
                  <MapPin className="w-12 h-12 text-brand-hunter mx-auto mb-4" data-id="element-253" />
                  <h3 className="text-2xl font-serif text-brand-charcoal mb-2" data-id="element-254">
                    Find Us in Lake Benton
                  </h3>
                  <p className="text-brand-charcoal/70 mb-8" data-id="element-255">
                    Located in rural Minnesota, offering a massive selection
                    worth the drive.
                  </p>
                  <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-brand-hunter text-brand-offwhite px-6 py-3 rounded-sm font-medium hover:bg-brand-wood transition-colors" data-id="element-256">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-257" />
                    View on Google Maps
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}